import { Box, Typography } from '@wishket/design-system';
import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface RootProps extends PropsWithChildren {
  className?: string;
}

export const Root = ({ children, className }: RootProps) => {
  return (
    <Box
      className={twMerge(
        'flex flex-col gap-5 rounded-2xl border border-w-gray-200 p-4 desktop:p-6 desktop:pt-5',
        className
      )}
    >
      {children}
    </Box>
  );
};

export const TypographyChip = ({ children }: PropsWithChildren) => {
  return (
    <Typography
      variant="body1"
      className="rounded-lg border border-primary-50 bg-primary-10 px-1.5 py-0.5 font-bold text-primary"
    >
      {children}
    </Typography>
  );
};

export const ItemContainer = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <Box
      className={twMerge(
        'flex h-[186px] w-full flex-col gap-5 rounded-2xl bg-w-gray-10 p-5',
        className
      )}
    >
      {children}
    </Box>
  );
};
